import { Address } from './address.model';
import { DictionaryItem } from './dictionary-item.model';

export interface Employee {
  firstName: string | null;
  lastName: string | null;
  birthDate: string; // ISO date string (YYYY-MM-DD)
  phoneNumber: string | null;
  communicationEmail: string | null;
  nationality: DictionaryItem | null;
  residentialAddress: Address | null;
  lookingForWork: boolean;
  competence: EmployeeCompetence;
  registrationStatus: EmployeeRegistrationStatus;
}

export const EMPLOYEE_REGISTRATION_STATUSES = {
  STEP_ONE: 'STEP_ONE',
  STEP_TWO: 'STEP_TWO',
  STEP_THREE: 'STEP_THREE',
  STEP_FOUR: 'STEP_FOUR',
  COMPLETED: 'COMPLETED',
} as const;

export type EmployeeRegistrationStatus =
  (typeof EMPLOYEE_REGISTRATION_STATUSES)[keyof typeof EMPLOYEE_REGISTRATION_STATUSES];

export interface EmployeeCompetence {
  desiredOccupationalProfiles: EmployeeOccupationalProfile[];
  occupationalProfiles: EmployeeOccupationalProfile[];
  excludeOccupationalProfiles: EmployeeOccupationalProfile[];
  transport: Transport;
  languages: Language[];
  drivingLicenses?: DrivingLicence[];
}

export interface DrivingLicence {
  type: DictionaryItem;
  validUntil: string | null;
  media?: DrivingLicenseMedia | null;
}

export interface DrivingLicenseMedia {
  name: string;
  key: string;
}

export interface EmployeeOccupationalProfile {
  occupationalProfileId: string | null;
  occupationalProfileName: string;
}

export interface Language {
  language: DictionaryItem | null;
  skillLevel: DictionaryItem | null;
}

export interface LanguageOption {
  name: string;
  code: string;
  primary: boolean;
}

export interface Transport {
  transportType: DictionaryItem | null;
  travelDistance: number;
}
